module.exports = __webpack_public_path__ + "img/wiping-swipe-for-floors-white.94d5cab9.svg";